import React from 'react';
import { WhatsApp } from '@mui/icons-material';
import '../sass/hablamos_whatsapp.scss';

type Props = {
    telefono: string;
    mensaje?: string;
};

// En desktop el texto "Hablamos?" se muestra siempre (sin ciclo de ocultar).
const HablamosWhatsapp = ({
    telefono,
    mensaje,
}: Props) => {
    if (!telefono) return null;

    const numero = telefono.replace(/\D/g, '');
    const texto = mensaje ? `?text=${encodeURIComponent(mensaje)}` : '';
    const href = `https://wa.me/${numero}${texto}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="hablamos-whatsapp"
            aria-label="Escribinos por WhatsApp"
            title="Escribinos por WhatsApp"
        >
            <span className="hablamos-whatsapp__texto visible">
                ¿Hablamos?
            </span>
            <span className="hablamos-whatsapp__icono">
                <WhatsApp fontSize="inherit" />
            </span>
        </a>
    );
};

export default HablamosWhatsapp;
